export default __webpack_public_path__ + "static/media/userSearch.c38ac508.svg";